var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Resizable } from "react-resizable";
export const resizableColumnsTableWrapper = (TableComponent) => {
    return class ResizableColumns extends React.Component {
        constructor(props) {
            super(props);
            this.resizableTitle = (props) => {
                const { onResize, width } = props, restProps = __rest(props, ["onResize", "width"]);
                if (!width) {
                    return <th {...restProps}/>;
                }
                return (<Resizable width={width} height={0} onResize={onResize} draggableOpts={{ enableUserSelectHack: false }}>
          <th {...restProps}/>
        </Resizable>);
            };
            this.components = {
                header: {
                    cell: this.resizableTitle.bind(this),
                },
            };
            this.handleResize = (index, _e, data) => {
                const { size } = data;
                const { columns } = this.state;
                columns[index].width = size.width;
                this.setState({ columns });
            };
            this.state = {
                columns: props.columns ? props.columns : [],
            };
        }
        render() {
            const restProps = __rest(this.props, []);
            const { columns } = this.state;
            const newColumns = columns.map((col, index) => (Object.assign(Object.assign({}, col), { onHeaderCell: (column) => ({
                    width: column.width,
                    onResize: this.handleResize.bind(this, index)
                }) })));
            return (<TableComponent {...restProps} columns={newColumns} components={this.components} className="resizable-table-columns"/>);
        }
    };
};



// WEBPACK FOOTER //
// ./components/resizablecell/resizableTable.tsx